import {
    type TextStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimeInputDynamicStyle
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    input: {
        textAlignVertical: "center",
        verticalAlign: "middle",
        textAlign: "center"
    },
    container: {
    }
});

export const useStyles = ({
    typography,
    radiuses
}: TimeInputDynamicStyle) => {
    const styles = {
        container: {
            borderRadius: radiuses.actions
        } as Mutable<ViewStyle>,
        input: {
            ...typography.titleMediumSize
        } as Mutable<TextStyle>
    };

    return styles;
};
export default stylesheet;
